import PropTypes from 'prop-types';
import { useContext } from 'react';
import { useIsGlobetrotter } from '@bwoty-web/ui-kit/hooks';
import { ArrowLink, Icon, Rating } from '@bwoty-web/ui-kit';
import {
  MEDIA_CAMERA_UNAVAILABLE,
  TIME_LOCATION_CALENDAR,
} from '@bwoty-web/ui-kit/icons';

import GlobalContext from '../../context/globalContext';
import { getCloudinaryUrl } from '../../utils/imageUtils';

import './cruisePackageInfoHotel.scss';

const CruisePackageInfoHotel = ({ hotel }) => {
  const { labels, siteSettings } = useContext(GlobalContext);
  const isGlobetrotter = useIsGlobetrotter();

  const hotelImage = getCloudinaryUrl(
    siteSettings.imageDomain,
    hotel.hotelImage?.path,
    110,
    150,
  );

  const hotelPopUpUrl = `${hotel.url}?pageTemplate=popUpPage&qf=popUpPage`;

  return (
    <>
      <div className="iw-cruise-package-info-hotel">
        {hotel.hotelImage ? (
          <div className="iw-cruise-package-info-hotel__image">
            <a href={hotelPopUpUrl}>
              <img alt={hotel.hotelImage?.alt} src={hotelImage} />
            </a>
          </div>
        ) : (
          <Icon
            className="iw-cruise-package-info-hotel__no-image-icon"
            path={MEDIA_CAMERA_UNAVAILABLE}
            size="xl"
            sizeMobile="l"
          />
        )}
        {hotel.url ? (
          <div className="iw-cruise-package-info-hotel__content">
            {isGlobetrotter && (
              <div className="iw-cruise-package-info-hotel__duration--isGlobetrotter">{`${hotel.checkIn} - ${hotel.checkOut}`}</div>
            )}
            <div className="iw-cruise-package-info-hotel__nameNResort-container">
              <a href={hotelPopUpUrl}>
                <p className="iw-cruise-package-info-hotel__hotel-name">
                  {hotel.name}
                </p>
              </a>
              <div className="iw-cruise-package-info-hotel__resort">
                {hotel.geographical?.resort?.name}
              </div>
            </div>
            <Rating rating={hotel.hotelRating} size="small" />
            {labels.readMoreHotel && (
              <ArrowLink href={hotelPopUpUrl}>{labels.readMoreHotel}</ArrowLink>
            )}
          </div>
        ) : (
          <div className="iw-cruise-package-info-hotel__content">
            <div className="iw-cruise-package-info-hotel__hotel-name--extend">
              {hotel.name}
            </div>
          </div>
        )}
      </div>
      {!isGlobetrotter && (
        <div className="iw-cruise-package-info-hotel__duration">
          <Icon
            className="iw-cruise-package-info-hotel__duration-icon"
            path={TIME_LOCATION_CALENDAR}
            role="button"
          />
          <span>{`${hotel.checkIn} - ${hotel.checkOut}`}</span>
        </div>
      )}
    </>
  );
};

CruisePackageInfoHotel.propTypes = {
  hotel: PropTypes.shape({
    checkIn: PropTypes.string,
    checkOut: PropTypes.string,
    geographical: PropTypes.shape(),
    hotelImage: PropTypes.shape(),
    hotelRating: PropTypes.number,
    name: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
};

export default CruisePackageInfoHotel;
